import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72ad7321"),n=n(),_popScopeId(),n)
const _hoisted_1 = { align: "center" }
const _hoisted_2 = {
  class: "imprint",
  align: "start",
  style: {"font-family":"Verdana, Geneva, Tahoma, sans-serif"}
}
const _hoisted_3 = {
  class: "mt-10",
  style: {"font-size":"xxx-large"}
}
const _hoisted_4 = { class: "mt-2 mb-1" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  class: "mt-2",
  style: {"font-weight":"bold"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-2 mb-1" }, "Team", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import FooterComponent from "@/components/Footer/FooterComponent.vue"

import { useI18n } from "vue-i18n"
import { computed } from "vue"
import { useMeta } from "vue-meta"
import HospitalHeader from "@/components/Hospitals/Headers/HospitalHeader.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutUsHospital',
  setup(__props) {

FooterComponent
const { t } = useI18n()
useMeta(
  computed(() => ({
    title: t("about-us"),
  }))
)
const formattedFirstLine = computed(() => {
  return t("about-us.first-line").replace("CIRCLE", "<strong>CIRCLE</strong>")
})
const formattedSecondLine = computed(() => {
  return t("about-us.second-line")
    .replace("Medcircle", "<strong>Medcircle</strong>")
    .replace(" Medcircle", "<strong>Medcircle</strong>")
})
const formattedThirdLine = computed(() => {
  return t("about-us.third-line").replace(
    "Medcircle",
    "<strong>Medcircle</strong>"
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HospitalHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("about-us.about")), 1),
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("about-us.vision")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("p", { innerHTML: formattedFirstLine.value }, null, 8, _hoisted_5),
          _createElementVNode("p", { innerHTML: formattedSecondLine.value }, null, 8, _hoisted_6),
          _createElementVNode("p", { innerHTML: formattedThirdLine.value }, null, 8, _hoisted_7),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("about-us.fourth-line")), 1),
          _hoisted_9,
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("about-us.team")), 1)
        ]),
        _hoisted_10
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})